import UtilService from '../../services/util.service';
import { Action } from './action';
import { ActionHandler } from './action-handler';

/* @ngInject */
export default class ActionDispatcherService {
  private handlers: ActionHandler[] = [];

  public register(handler: ActionHandler) {
    this.handlers.push(handler);
  }

  public unregister(handler: ActionHandler) {
    UtilService.removeElement(this.handlers, handler);
  }

  public dispatch(action: Action) {
    action = UtilService.deepCopy(action);
    for (const handler of this.handlers) {
      handler.handle(action);
    }
  }
}



// WEBPACK FOOTER //
// src/app/common/actions/core/action-dispatcher.service.ts